import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import {
  article as ArticlePropType,
  newsletter as NewsletterPropType,
} from 'lib/CustomPropTypes';
import $t from 'lib/trackingService';

import { getNewsletterData as getNewsletterDataAction } from 'redux/modules/newsletter';

import SignupInput from '../SignupInput';
import verticalLogic from '../verticalLogic';
import { getInlineNewsletterConfig } from '../utils/getInlineNewsletterConfig';

$t('register', 'newsletter_subscribe');

const mapStateToProps = ({ shared, article, newsletter }, { vertical }) => ({
  article: get(article, 'content[0]') || null,
  newsletterData: get(newsletter, ['newsletterData', 'Newsletters'], []),
  vertical: vertical || shared.vertical,
});

const mapActionToProps = (dispatch) => ({
  getNewsletterData: (vertical) => dispatch(getNewsletterDataAction(vertical)),
});

@connect(mapStateToProps, mapActionToProps)
class NewsletterSignupWrapper extends React.Component {
  static propTypes = {
    article: ArticlePropType.isRequired,
    getNewsletterData: PropTypes.func,
    newsletterData: PropTypes.arrayOf(NewsletterPropType),
    vertical: PropTypes.string.isRequired,
  }

  static defaultProps = {
    getNewsletterData: Function.prototype,
    newsletterData: [],
  }

  componentDidMount() {
    const { getNewsletterData, vertical } = this.props;
    getNewsletterData(vertical);
  }

  onSubmit = () => {
    const {
      article,
      newsletterData,
    } = this.props;

    const newsletterConfig = getInlineNewsletterConfig(article, newsletterData);

    if (newsletterConfig) {
      const {
        newsletterKey: id,
        newsletterSignupSource: placement,
      } = newsletterConfig;

      if (id && placement) {
        $t('track', 'newsletter_subscribe', { id, placement });
      }
    }
  };

  render() {
    const {
      article,
      newsletterData,
      vertical,
    } = this.props;

    const { stKey } = verticalLogic(vertical, article);
    const newsletterConfig = getInlineNewsletterConfig(article, newsletterData);

    if (newsletterConfig) {
      const newsletterTitle = get(newsletterConfig, 'newsletterTitle', null);
      const newsletterDescription = get(newsletterConfig, 'newsletterDescription', null);
      const newsletterKey = get(newsletterConfig, 'newsletterKey', null);
      const newsletterSignupSource = get(newsletterConfig, 'newsletterSignupSource', null);

      return (
        <div className="newsletter-signup__container">
          {newsletterTitle && <p className="newsletter-signup__title">{newsletterTitle}</p>}
          {newsletterDescription && <div className="newsletter-signup__descr">{newsletterDescription}</div>}
          <SignupInput
            newsletterId={newsletterKey}
            onSubmit={this.onSubmit}
            signupSource={newsletterSignupSource}
            sitekey={stKey}
            vertical={vertical}
          />
        </div>
      );
    }
    return null;
  }
}

export default NewsletterSignupWrapper;
